export const createUploadState = ({ config, hiddenInput }) => {
	const uploadedFiles = new Map();

	const syncHiddenInput = () => {
		const fileList = Array.from(uploadedFiles.values()).map((file) => ({
			file_id: file.fileId,
			storage_key: file.storageKey,
			original_name: file.originalName,
			mime_type: file.mimeType,
			file_size: file.fileSize,
			timestamp: file.timestamp,
		}));

		if (!config.uploadMultiple && fileList.length > 1) {
			hiddenInput.value = JSON.stringify([fileList[fileList.length - 1]]);
			return;
		}

		hiddenInput.value = fileList.length ? JSON.stringify(fileList) : '';
	};

	return {
		clear() {
			const files = Array.from(uploadedFiles.values());
			uploadedFiles.clear();
			syncHiddenInput();
			return files;
		},
		get(fileId) {
			return uploadedFiles.get(fileId);
		},
		set(fileId, file, uploadData) {
			uploadedFiles.set(fileId, {
				fileId,
				filename: file.name,
				storageKey: uploadData.storage_key,
				originalName: file.name,
				mimeType: uploadData.mime_type || file.type,
				fileSize: Number(uploadData.file_size || file.size),
				timestamp: Math.floor(Date.now() / 1000),
			});

			syncHiddenInput();
		},
		delete(fileId) {
			uploadedFiles.delete(fileId);
			syncHiddenInput();
		},
		syncHiddenInput,
	};
};
